import React from 'react'

const ViewMessage = () => {
  return (
    <h1>ViewMessage</h1>
  )
}

export default ViewMessage